<div class="cartPreview__total">
  <span class="cartPreview__total__label" i18n="@@HEADER.FLOATING_CART.SUBTOTAL">Subtotal</span>
  <span class="cartPreview__total__amount">{{ currentCart?.itemsAmount.formatted }}</span>
</div>
